<template>
<div class="paging_ui" v-if="showCount != 0">
  <a href="javascript:void(0);" class="pre" :class="thisPage > size? null : 'disabled'" @click="prevPage(cnt + cntRef)">이전</a>
  <a href="javascript:void(0);" class="num" v-for="cnt in showCount" :class="{selectd:cnt == (thisPage - cntRef)}" @click="selectPage(cnt + cntRef)">{{cnt + cntRef}}</a>
  <a href="javascript:void(0);" class="next" :class="pageTotalCnt > cntRef + size? null : 'disabled'" @click="nextPage(cnt + cntRef)">다음</a>
</div>
</template>

<script>
export default {
  props: {
    pageCnt : {
      type: Number,
      default(){
        return 1
      }
    },
    pageTotalCnt: {
      type: Number,
      default() {
        return 0
      }
    },
    size: Number
  },
  data() {
    return {
      thisPage: 0,
      cntRef: 0,
      cnt: 0,
      showCount: 0,
    }
  },
  watch: {
    pageTotalCnt (value) {
      this.pageCounting();
    },
    thisPage (value) {
      this.pageCounting();
    },
    pageCnt(value){
      this.thisPage = value;
    }
  },
  created(){
  },
  mounted() {
    this.emitInterface()
    this.thisPage = this.pageCnt;
    this.pageCounting()
  },
  methods: {
    emitInterface() {
      this.$emit('setMethod', {pageCounting : this.pageCounting});
    },
    pageCounting() {
      if(this.pageTotalCnt < this.thisPage) {
        this.thisPage = 1;
        this.cntRef = 0;
      }
      if(this.thisPage > this.cntRef) {
        this.cntRef += this.size
      }
      if(this.thisPage <= this.cntRef) {
        this.cntRef -= this.size
      }
      this.showCount = Math.min(this.pageTotalCnt - this.cntRef, this.size);
    },
    selectPage (index) {
      this.thisPage = index;
      this.$emit('click', index);
    },
    prevPage () {
      if(!(this.thisPage > this.size)){
        return;
      }
      this.thisPage = this.cntRef;
      this.thisPage = this.thisPage <= 0 ? 1 : this.thisPage;
      this.$emit('click', this.thisPage)
    },
    nextPage () {
      if(!(this.pageTotalCnt > this.cntRef + this.size)){
        return;
      }
      this.thisPage = this.cntRef + this.size + 1;
      this.$emit('click', this.thisPage);
    }
  }
}
</script>

<style lang="scss">
  .pagination {
    display: flex; align-items: center; justify-content: center;
    min-height: 20px;
    gap: 15px;
    a {
      display: block;
      @include text-prt;
      font-size: var( --default-gap );
      color: #999;
      &.on {
        color: #333;
        @include text-prt-b;
      }
      &.prev {
        width: 10px; height: 10px;
        font-size: 0;
        background: url('../../assets/icons/pagination-prev.svg') center center no-repeat;
      }
      &.next {
        width: 10px; height: 10px;
        font-size: 0;
        background: url('../../assets/icons/pagination-next.svg') center no-repeat;
      }
    }
  }
</style>